export default __webpack_public_path__ + "static/media/history_img_2.5068fb1e.png";